import get from 'lodash.get';

const getPartnerProperties = (rootState) => get(rootState, 'user.partnerData.properties', {});

export default getPartnerProperties;
